import React from "react";
import { motion } from "framer-motion";
import { useLanguage } from "@/context/LanguageContext";
import { MapPin, NavigationArrow } from "@phosphor-icons/react";

export default function MapSection() {
  const { t } = useLanguage();

  return (
    <section className="py-24 md:py-32 bg-[#050505]" data-testid="map-section">
      <div className="max-w-7xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <p className="text-xs uppercase tracking-[0.25em] text-[#FFD700] mb-4 font-light">{t.map.overline}</p>
          <h2 className="font-['Cormorant_Garamond'] text-3xl md:text-5xl font-light text-white tracking-tight">{t.map.title}</h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="grid grid-cols-1 lg:grid-cols-3 gap-6"
        >
          {/* Map */}
          <div className="lg:col-span-2 border border-white/10 overflow-hidden h-[400px]" data-testid="google-map">
            <iframe
              title="Dominican Upholstered Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3023.5!2d-74.2157!3d40.6795!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c24d38a6e4c5a7%3A0x0!2s1045+North+Broad+St%2C+Elizabeth%2C+NJ+07208!5e0!3m2!1sen!2sus!4v1700000000000"
              width="100%"
              height="100%"
              style={{ border: 0, filter: "invert(90%) hue-rotate(180deg)" }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>

          {/* Info Card */}
          <div className="bg-[#121212] border border-white/10 p-8 flex flex-col justify-between">
            <div>
              <div className="flex items-center gap-3 mb-6">
                <div className="w-10 h-10 flex items-center justify-center bg-[#FFD700]">
                  <MapPin size={22} weight="fill" className="text-black" />
                </div>
                <h3 className="font-['Cormorant_Garamond'] text-xl text-white">{t.map.visitUs}</h3>
              </div>

              <div className="space-y-4 mb-8">
                <div>
                  <p className="text-zinc-500 text-xs uppercase tracking-wider mb-1">{t.map.address}</p>
                  <p className="text-white text-sm font-light leading-relaxed">1045 North Broad St.<br />Elizabeth, NJ 07208</p>
                </div>
                <div>
                  <p className="text-zinc-500 text-xs uppercase tracking-wider mb-1">{t.map.hours}</p>
                  <p className="text-white text-sm font-light">{t.map.weekdays}</p>
                  <p className="text-white text-sm font-light">{t.map.saturday}</p>
                  <p className="text-zinc-500 text-sm font-light">{t.map.sunday}</p>
                </div>
                <div>
                  <p className="text-zinc-500 text-xs uppercase tracking-wider mb-1">{t.map.serviceArea}</p>
                  <p className="text-white text-sm font-light">{t.map.areas}</p>
                </div>
              </div>
            </div>

            <a
              href="https://maps.google.com/?q=1045+North+Broad+St+Elizabeth+NJ+07208"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center gap-2 py-3 bg-[#FFD700] text-black text-sm font-medium uppercase tracking-wider hover:bg-[#E5C100] transition-colors"
              data-testid="get-directions-btn"
            >
              <NavigationArrow size={16} weight="bold" />
              {t.map.directions}
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
